import React from "react";
import { useState, useEffect } from "react";
import AppContext from "../Context/Context";
import * as XLSX from "xlsx";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import { useGlobalState } from "../Context/GlobalStateContext";
type MyNotificationsProps = {
  ObjectType: any;
  ObjectIds: any;
};
function NotificationsPreview(props: MyNotificationsProps) {
  const [showAnimation, setShowAnimation] = useState(false);
  const [showNotifications, setNotifications] = useState(false);
  const [notificationsListsData, setNotificationsListsData] = useState<any>([]);
  const [totalCount, setTotalCount] = useState(0);
  const globalState = useGlobalState();
  useEffect(() => {
    getNotificationsStatsData();
  }, [globalState.UpdateNotificationCount]);

  function getNotificationsStatsData() {
    let object = {} as any;
    object.objecttype = props.ObjectType;
    object.objectids = props.ObjectIds;
    object.linkedobjecttype = 1;
    object.linkedobjectids = "";
    object.typeofdata = 1;
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/PFINotification/GetNotificationsStatsData",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          setTotalCount(l_response[0][0].TotalCount);
          setNotificationsListsData(l_response[1]);
          console.log(l_response);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function setNotificationsStatusDataLocally(
    pid: any,
    actiontype: any,
    index: any
  ) {
    let thisNotificationsListsData = [...notificationsListsData];

    if (actiontype == 1) {
      thisNotificationsListsData[index].IsRead =
        !thisNotificationsListsData[index].IsRead;
    } else if (actiontype == 2) {
      thisNotificationsListsData[index].IsFlag =
        !thisNotificationsListsData[index].IsFlag;
    }

    setNotificationsListsData(thisNotificationsListsData);
    setNotificationsStatusData(pid, actiontype);
  }

  function setNotificationsStatusData(pid: any, actiontype: any) {
    let object = {} as any;
    object.pid = pid;
    object.actiontype = actiontype;
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/PFINotification/SetNotificationsStatusData",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          getNotificationsStatsData();
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  return (
    <>
      {showAnimation && <LoadingAnimation />}
      {globalState.ManageAdmin && globalState.AppAccessLevelData.DID == 0 && (
        <div className="folder-inn">
          <a
            onClick={() => setNotifications(!showNotifications)}
            className="p-relative"
          >
            <img src="/images/bell.svg" width="25px" height="20" />
            {totalCount > 0 && (
              <span className="notify-count notify-head">{totalCount}</span>
            )}
          </a>
          {showNotifications && (
            <div className="notify-drop">
              <div className="drop-btns-read">
                <a href="/mynotifications" className="n-btn-view">
                  View All
                </a>
                <a href="/mynotifications?ur=true" className="n-btn-unread">
                  {totalCount} Unread
                </a>
              </div>
              {notificationsListsData &&
                notificationsListsData.map((item: any, index: any) => (
                  <div
                    key={index}
                    className={`n-drop-row ${item.IsRead ? "" : "notify-Bold"}`}
                  >
                    {/* <span>{item.Title1} - </span>
                  <span>{item.Title2} - </span> */}
                    <a className="drop-display-text" href={item.SourceLink}>
                      {item.DisplayText}
                    </a>
                    <a
                      onClick={() =>
                        setNotificationsStatusDataLocally(
                          item.PFINotificationUserID,
                          1,
                          index
                        )
                      }
                    >
                      {item.IsRead && (
                        <img src="images/read.svg" width={22} height={22} />
                      )}
                      {!item.IsRead && (
                        <img src="images/unread.svg" width={22} height={22} />
                      )}
                      {/* {item.IsRead == true ? "read" : "unread"} */}
                    </a>
                  </div>
                ))}
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default NotificationsPreview;
